import { useMemo } from 'react';

import { useUserPractice } from '@modules/user/hooks/useUserPractice';

import { OptionType } from '@components/Select';

import { usePractice } from '@modules/organization/hooks/usePractice';
import first from 'lodash/first';

interface Params {
    assistantId: string;
}

interface UsePracticeOptions {
    selectedPracticeId?: string;
    practiceOptions: OptionType<string>[];
    getPracticeName(practiceId: string): string;
}

export const usePracticeOptions = ({ assistantId }: Params): UsePracticeOptions => {
    const { practiceWithTgLint } = useUserPractice({ userId: assistantId });
    const { getPracticeName } = usePractice();

    const practiceOptions: OptionType<string>[] = useMemo(
        () =>
            practiceWithTgLint.map(practice => ({
                value: practice.id,
                label: getPracticeName(practice.id),
            })),
        [practiceWithTgLint, getPracticeName],
    );

    const selectedPracticeId = useMemo(() => first(practiceOptions)?.value, [practiceOptions]);

    return {
        selectedPracticeId,
        practiceOptions,
        getPracticeName,
    };
};
